module.exports = __webpack_public_path__ + "d96bc483e2f21afb527f8bff3ae885d7.pdf";